<template>
  <div
    v-if="partnerType === 'BOTH'"
    v-tooltip.top-start="{
      content: isAdmin ? 'not allowed as admin' : null,
      hideOnTargetClick: false,
    }"
    class="delete-showroom"
  >
    <button
      class="btn text-btn icon-btn link-red"
      :disabled="isAdmin"
      @click.prevent="!isAdmin && openDialog()"
    >
      <Icon icon="bin" />
      {{ $t('GENERAL.DELETE') }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useStore } from 'vuex';
import dialogService from 'commons/dialogs/wrapper/dialogService';
import PublishingShowroomDeletionDialog from 'src/app/partnerarea/pos/showroom/PublishingShowroomDeletionDialog.vue';
import analyticsService from 'commons/tracking/analytics';
import ConfirmDialog from 'commons/dialogs/confirm/ConfirmDialog.vue';
import { useRouter } from 'vue-router';
import { PUBLISHING_SCOPE } from 'commons/publishing/publishingScope';
import { useCompositionsStore } from 'commons/stores/compositions';

const store = useStore();
const compositionsStore = useCompositionsStore();
const router = useRouter();

const isAdmin = store.getters['user/isAdmin'];
const partnerType = store.getters['user/partnerType'];

const openDialog = () => {
  analyticsService.logEvent('remove_marketplace_header_click');

  if (compositionsStore.posStateCounts.total > 0) {
    openCompositionAndShowroomDeletionDialog();
  } else {
    openDeletionDialog();
  }
};
const openCompositionAndShowroomDeletionDialog = async () => {
  try {
    await dialogService.openDialog(PublishingShowroomDeletionDialog);
  } catch (_) {
    // modal dismissed
  }
};
const openDeletionDialog = async () => {
  try {
    await dialogService.openDialog(ConfirmDialog, {
      heading: 'POS.MARKETPLACE.DELETION.HEADING',
      description: 'POS.MARKETPLACE.DELETION.DESCRIPTION',
    });

    analyticsService.logEvent('remove_marketplace_delete');

    await store.dispatch('settings/setSetting', {
      key: 'MP_ENABLED',
      value: false,
    });
    router.push({ name: 'partnerarea.dashboard' });
    // this.addToast({
    //   variant: 'black',
    //   text: 'POS.MARKETPLACE.DELETION.TOAST',
    //   hideIcon: true,
    // });
  } catch (_) {
    // modal dismissed
  }
};

onMounted(async () => {
  compositionsStore.setFilter({ query: null });
  await compositionsStore.fetchPosStateCounts(PUBLISHING_SCOPE.MP.key);
});
</script>

<style lang="scss" scoped></style>
